import { useTheme, styled } from '@mui/material/styles';
import {
  Avatar,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AuthContext } from 'App';
import { IconBuildingStore } from '@tabler/icons-react';
import ApiCall from 'services/axiosConfig';

// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  padding: 16,
  '&:hover': {
    background: theme.palette.primary.light,
  },
  '& .MuiListItem-root': {
    padding: 0,
  },
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = (props) => {
  const theme = useTheme();

  const { notificationData, setNotificationData } = props;
  const { notification } = useContext(AuthContext);

  // State to manage notifications

  useEffect(() => {
    if (notification) {
      console.log('object', notification);
      setNotificationData((prevNotifications) => [
        // notification,
        ...prevNotifications,
      ]);
    }
  }, [notification]);

  const markNotifications = async (value) => {
    console.log('mark Notifications called :>> ', value);
    try {
      const markNotification = await ApiCall.SECURE_API.put(
        `/notification/${value}`,
        {
          read: true,
        }
      );
      const { data } = markNotification;
      console.log('markNotificatoin :>> ', markNotification);
      if (data) {
        console.log('response', data);
        const { success, message } = data;
        if (success) {
          // setDeptData(departments);
          // setLoading(false);
          toast.success(message || 'Notification marked as read');
        }
      }
    } catch (err) {
      console.error(err);
      // setLoading(false);
      if (err.code == 'ERR_NETWORK') {
        toast.error(err.message);
      } else if (err.response?.status) {
        toast.error(err.response?.data?.message);
      }
    }
  };

  const handleDismiss = (id) => {
    markNotifications(id);
    setNotificationData((prevNotifications) =>
      prevNotifications.filter((notification) => notification._id !== id)
    );
    toast.info('Notification Seen');
  };

  return (
    <List
      sx={{
        width: '100%',
        maxWidth: 330,
        pb: 0,
        pt: 2,
        borderRadius: '10px',
        [theme.breakpoints.down('md')]: {
          maxWidth: 300,
        },
        '& .MuiListItemSecondaryAction-root': {
          top: 22,
        },
        '& .MuiDivider-root': {
          my: 0,
        },
        '& .list-container': {
          pl: 7,
        },
        '& .css-1j7g6on': {
          cursor: 'pointer',
          paddingX: '12px',
          paddingY: '1px',
        },
      }}
    >
      {/* {notification?.map((notification) => (
        <ListItemWrapper>
          <div
            style={{
              position: 'relative',
              //borderBottom: '1px solid #AFAFAF',
              padding: '7px',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                right: 1,
                cursor: 'pointer',
                transform: 'translateY(-50%)',
              }}
              onClick={() => handleDismiss(notification._id)}
            >
              <CloseOutlinedIcon style={{ color: '#9A9A9A' }} />
            </div>
          </div>
          <ListItem alignItems='center'>
            <ListItemAvatar>
              <Avatar
                sx={{
                  color: theme.palette.success.dark,
                  backgroundColor: theme.palette.success.light,
                  border: 'none',
                  borderColor: theme.palette.success.main,
                }}
              >
                <IconBuildingStore stroke={1.5} size='1.3rem' />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={notification?.type} />
            <ListItemSecondaryAction>
              <Grid container justifyContent='flex-end'>
                <Grid item xs={12}>
                  <Typography variant='caption' display='block' gutterBottom>
                    {new Date(notification?.createdAt).toLocaleTimeString(
                      'en-GB',
                      {
                        hour12: true,
                        hour: '2-digit',
                        minute: '2-digit',
                      }
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </ListItemSecondaryAction>
          </ListItem>
          <Grid container direction='column' className='list-container'>
            <Grid item xs={12} sx={{ pb: 2 }}>
              <Typography variant='subtitle2'>
                {notification?.message}
              </Typography>
            </Grid>
          </Grid>
        </ListItemWrapper>
      ))} */}
      {notificationData.map((notification) => (
        <ListItemWrapper key={notification._id}>
          {/* <div
            style={{
              position: 'relative',
              padding: '7px',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                right: 1,
                cursor: 'pointer',
                transform: 'translateY(-50%)',
              }}
              onClick={() => handleDismiss(notification._id)}
            >
              <CloseOutlinedIcon style={{ color: '#9A9A9A' }} />
            </div>
          </div> */}
          <ListItem alignItems='center'>
            <ListItemAvatar>
              <Avatar
                sx={{
                  color: theme.palette.success.dark,
                  backgroundColor: theme.palette.success.light,
                  border: 'none',
                  borderColor: theme.palette.success.main,
                }}
              >
                <IconBuildingStore stroke={1.5} size='1.3rem' />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={notification.type} />
            <ListItemSecondaryAction>
              <Grid container justifyContent='flex-end'>
                <Grid item xs={12}>
                  <Typography variant='caption' display='block' gutterBottom>
                    {new Date(notification.createdAt).toLocaleTimeString(
                      'en-GB',
                      {
                        hour12: true,
                        hour: '2-digit',
                        minute: '2-digit',
                      }
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </ListItemSecondaryAction>
          </ListItem>
          <Grid container direction='column' className='list-container'>
            <Grid item xs={12} sx={{ pb: 2 }}>
              <Typography variant='subtitle2'>
                {notification.message}
              </Typography>
            </Grid>
          </Grid>
        </ListItemWrapper>
      ))}
    </List>
  );
};

export default NotificationList;
